import React from 'react'
import { setDocumentTitle, isRtl } from 'src/helper/tool'
import './index.less'
import { getlangV2, setlang } from 'src/helper/getlang'
import lang from '../lang'
import brower from 'src/helper/brower'
import { history } from 'src/core/router'
import hybridRouter from 'src/core/hybrid-router'
import config from 'src/core/config'
import jump from 'src/helper/jumpToApp'

const { appLink } = jump
const { vocaAPK } = appLink
export default class extends React.Component {
  constructor(props) {
    super(props)
    setDocumentTitle(`Voca - A voice-based social app`)
  }

  state = {
    lang: lang.en,
    language: 'en',
    activeLang: {
      text: 'English',
      key: 'en'
    },
    langList: [
      {
        text: 'English',
        key: 'en'
      },
      {
        text: 'بالعربية',
        key: 'ar'
      },
      {
        text: 'Türkçe',
        key: 'tr'
      },
      {
        text: 'Português',
        key: 'pt'
      },
      {
        text: 'indonésio',
        key: 'id'
      },
      {
        text: 'Русский',
        key: 'ru'
      },
      {
        text: "O'zbek",
        key: 'uz'
      },
      {
        text: 'فارسی',
        key: 'fa'
      },
      {
        text: 'اردو',
        key: 'ur'
      }
    ],
    hostHybrid: config.hostHybrid
  }

  async componentDidMount() {
    this.goMoblie()
    let { language } = this.props.location.query
    const { langList } = this.state
    language = await getlangV2(language, lang)
    const activelang = langList.find(item => item.key === language) || langList[0]
    // console.log('componentDidMount', activelang)
    this.setState({
      lang: setlang(language, lang),
      language: activelang.key,
      activeLang: activelang
    }, () => {
      setDocumentTitle(this.state.lang.title)
    })
  }

  goMoblie() {
    if (brower.isIphone() || brower.isAndroid() || brower.isWeixin()) {
      history.push({
        pathname: `/`,
        query: {
          code: this.props.location.query.code,
          c: this.props.location.query.c,
          activity: this.props.location.query.activity
        }
      })
    }
  }

  onChangeLang (item) {
    this.setState({
      language: item.key,
      activeLang: item,
      lang: setlang(item.key, lang)
    }, () => {
      setDocumentTitle(this.state.lang.title)
    })
  }

  /**
 * @description 充值跳转
 */
  handleRecharge() {
    // history.push('/app/recharge')
    window.location.href = this.state.hostHybrid + hybridRouter.recharge
  }

  render() {
    const { lang, language, activeLang, langList } = this.state

    return (
      <div className='voca-home'>
        <div className={`page-hd ${isRtl(language) ? 'rtl' : ''}`}>
          <div className="logo-wrap">
            <div className="img-wrap">
              <img src="/img/voca-home/logo@2x.webp" alt="" />
            </div>
            <div className="text-wrap">
              <h1>Voca</h1>
              <p>{lang.subTitle}</p>
            </div>
          </div>
          <div className="btn-wrap">
            <div className="btn-item" onClick={() => this.handleRecharge()} >{lang.recharge}</div>
            <div className="btn-item lang-btn">
              <p className="lang-txt">
                { activeLang.text }
                <img src="/img/voca-home/arrow@2x.webp" />
              </p>
              <div className={`lang-list`}>
                {
                  langList.length > 0 && langList.filter(item => item.key !== language).map((item, index) => (
                    <div
                      className="lang-item"
                      key={index}
                      onClick={() => this.onChangeLang(item)}
                    >
                      {item.text}
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
        <div className={`page-cont ${isRtl(language) ? 'rtl' : ''}`}>
          <div className="text-wrap">
            <h2>{lang.pageTitle}</h2>
            <div className="desc-wrap">
              {lang.pageDesc}
            </div>
            <a className="btn-wrap" download={'voca'} target='_blank' href={vocaAPK}>
              <img src="/img/voca-home/apk@2x.webp" />
              <div className="title-wrap">
                <p>{lang.download}</p>
                <p>(.apk {lang.file})</p>
              </div>
            </a>
          </div>
          <div className="video-wrap">
            <img src="/img/voca-home/voca-app-pc@2x.webp" />
          </div>
        </div>
        <div className='copyright'>
          Copyright ©2025 Voca HABI TECHNOLOGY LIMITED UNIT D18,3/F WONG KING INDBLDG NO.2-4 TAI YAU ST SAN POKONG
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/voca-home/pc/index.js